import { type ChangeEvent, type ReactNode } from 'react';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';

import { type FormInputProps } from './types';
import { useFormInputChange } from './useFormInputChange';

type CheckboxProps = FormInputProps<boolean> & {
  label: ReactNode;
};

const Checkbox = (props: CheckboxProps) => {
  const { value, label, className, disabled } = props;
  const emit = useFormInputChange(props);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) =>
    emit(event.target.checked);

  return (
    <LabeledCheckbox
      checked={value}
      onChange={handleChange}
      label={label}
      className={className}
      disabled={disabled}
    />
  );
};

export default Checkbox;
